<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <div class="mb-1">
            <span style="font-size: 14px; color: #606266">
              Port No：{{ formData.portNo ? formData.portNo : 'New' }}
            </span>
            <el-divider direction="vertical"></el-divider>
            <b-badge
              style="font-size: 12px"
              :variant="
                formData.portStatus === 'Y'
                  ? 'success'
                  : formData.portStatus === 'N'
                  ? 'danger'
                  : 'primary'
              "
            >
              {{ formData.v_portStatus ? formData.v_portStatus : '--' }}
            </b-badge>
            <el-divider direction="vertical"></el-divider>
            <span style="font-size: 14px; color: #606266">
              Update：{{ formData.modifyByName ? formData.modifyByName : '--' }}
              at
              {{ formData.modifyDate ? formData.modifyDate : '--' }}
            </span>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('master_port_portName') || '港口名称'"
            prop="portName"
          >
            <el-input
              clearable
              v-model="formData.portName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('master_port_portFullName') || '港口全称'"
            prop="portFullName"
          >
            <el-input
              clearable
              v-model="formData.portFullName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('master_port_portRegion') || '地区代码'"
            prop="portRegion"
          >
            <el-input
              clearable
              v-model="formData.portRegion"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
            :label="$l('master_port_portCountry') || '国家全称'"
            prop="portCountry"
          >
            <el-input
              clearable
              v-model="formData.portCountry"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="50"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="$l('master_port_portDesc') || '港口说明'">
            <el-input
              clearable
              v-model="formData.portDesc"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              type="textarea"
              rows="3"
              size="small"
              maxlength="200"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    portCode: String,
    params: { type: Object, default: () => {} }
  },
  data() {
    return {
      formData: {},
      rules: {
        portName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur'
          }
        ],
        portRegion: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.portCode) return

      this.$api
        .mastePortDetailApi({
          portCode: this.portCode
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.loadingOpen()
      this.$api
        .mastePortSaveApi(this.formData)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success'
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存'
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    }
  }
}
</script>
